// extracted by mini-css-extract-plugin
module.exports = {"container":"_2oZ1KkDHtc9TjiTiP7vkJ2"};